<template>
    <v-dialog v-model="dialog" max-width="900">
      <v-card>
        <v-toolbar card dark color="primary">
          <v-toolbar-title>
            {{ 'app.edit_subscription' | trans }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark small @click="close">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout wrap align-center>
                <v-flex xs6>
                  <v-menu
                      v-model="startDateInput"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                          v-model="startDate"
                          @blur="subscription.start_date = parseDate(startDate)"
                          :label="'app.start_date' | trans"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                          :rules="rules.start_date"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="subscription.start_date"
                        @input="startDateInput = false"
                        locale="pl-pl"
                        first-day-of-week="1">
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs6>
                  <v-menu
                      v-model="endDateInput"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                          v-model="endDate"
                          @blur="subscription.end_date = parseDate(endDate)"
                          :label="'app.end_date' | trans"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                          :rules="rules.end_date"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="subscription.end_date"
                        @input="endDateInput = false"
                        locale="pl-pl"
                        first-day-of-week="1">
                    </v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="close">
            {{ 'app.close' | trans }}
          </v-btn>
          <v-btn color="primary" @click="save" :disabled="!valid"
                 :loading="loading">
            {{ 'app.save' | trans }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
import RulesBuilder from "../../../utils/rulesBuilder";
import {trans} from "../../../app";
import moment from "moment/moment";
import {FORMAT_DATE, SYSTEM_DATE} from "../../../utils/dateFormatter";

export default {
  data: function() {
    return {
      rulesBuilder: null,
      dialog: false,
      valid: false,
      loading: false,
      startDateInput: false,
      endDateInput: false,
      subscriptionId: null,
      startDate: '',
      endDate: '',
      subscription: {
        start_date: '',
        end_date: '',
      },
    }
  },
  props: {
    currentSubscription: Object,
  },
  created() {
    this.rulesBuilder = new RulesBuilder();
  },
  computed: {
    rules() {
      return {
        start_date: [
          ...this.rulesBuilder
              .addRequiredRule(trans('app.start_date'))
              .addDateIsBefore(
                  trans('app.start_date'),
                  trans('app.end_date'),
                  this.subscription.end_date
              )
              .getRules(),
        ],
        end_date: [
          ...this.rulesBuilder
              .addRequiredRule(trans('app.end_date'))
              .addDateIsAfter(
                  trans('app.end_date'),
                  trans('app.start_date'),
                  this.subscription.start_date
              )
              .getRules(),
        ]
      }
    },
  },
  watch: {
    currentSubscription: function(subscription) {
      if (subscription === null) {
        this.subscriptionId = null;
        this.subscription = {
          start_date: '',
          end_date: '',
        };
        this.startDate = '';
        this.endDate = '';
      } else {
        this.subscriptionId = subscription.id;
        this.subscription.start_date = subscription.start_date;
        this.subscription.end_date = subscription.end_date;
        this.startDate = this.formatDate(this.subscription.start_date);
        this.endDate = this.formatDate(this.subscription.end_date);
      }
    },
    'subscription.start_date'(startDate) {
      this.startDate = startDate ? this.formatDate(startDate) : '';
    },
    'subscription.end_date'(endDate) {
      this.endDate = endDate ? this.formatDate(endDate) : '';
    },
  },
  methods: {
    open: function() {
      this.$refs.form.reset();
      this.subscriptionId = null;
      this.dialog = true;
    },
    close: function () {
      this.dialog = false;
      this.$refs.form.reset();
      this.$emit('subscription_closed');
    },
    save: async function () {
      if (this.$refs.form.validate() === false) {
        return;
      }

      this.loading = true;
      try {
        await axios.put(`/administrator/subscriptions/${this.subscriptionId}`, this.subscription);
        this.$toast.success(trans('app.saved'));
      } catch (e) {
        this.$toast.error(trans('app.save_failed'));
        this.loading = false;
        return;
      }

      this.$emit('subscription_stored');
      this.close();
      this.loading = false;
    },
    formatDate(date) {
      if (!date) {
        return '';
      }
      return moment(date).format(FORMAT_DATE)
    },
    parseDate(date) {
      if (!date) {
        return '';
      }
      return moment(date, FORMAT_DATE).format(SYSTEM_DATE);
    },
  }
}
</script>
